export default [
  {
    disableBeacon: true,
    target: "#tour-playbook-dropdown",
    title: "View your custom compliance strategy",
    content: "The playbook is your step-by-step guide to compliance, it contains recommended actions for you based on the results of your assessment.",
    placement: "right"
  },
  {
    target: "#tour-playbook-item",
    title: "Here's your compliance to-do list!",
    content: "Click on a step in your playbook to start working on a compliance task.",
    placement: "bottom"
  }
]


// WEBPACK FOOTER //
// ./src/components/tour/playbook/steps.js